module.exports = __webpack_public_path__ + "img/button-icon-delete.e5de5f34.svg";